// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const wailord: PokeData = {
  "id": 321,
  "name": "wailord",
  "height": 145,
  "weight": 3980,
  "base_experience": 175,
  "types": [
    PokeType.WATER
  ],
  "api_moves": [
    "body-slam",
    "growl",
    "mist",
    "water-gun",
    "hydro-pump",
    "amnesia",
    "splash",
    "rest",
    "rollout",
    "whirlpool",
    "dive",
    "astonish",
    "water-spout",
    "bounce",
    "water-pulse",
    "brine",
    "heavy-slam",
    "soak",
    "noble-roar"
  ],
  "moves": [
    "body-slam",
    "growl",
    "hydro-pump",
    "splash",
    "whirlpool",
    "water-spout",
    "brine",
    "bubble",
    "life-dew",
    "aqua-cutter",
    "aqua-tail",
    "liquidation",
    "aqua-jet"
  ],
  "evolution_chain": {
    "id": 161,
    "item": null,
    "species": [
      {
        "name": "wailmer",
        "order": 348,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "wailord",
        "order": 349,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": 320,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 40,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 167,
    "speed": 93,
    "ability_power": 140
  },
  "stat_changes": [],
  "catch_rate": 60,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
